import { render, staticRenderFns } from "./BlacklistTable.vue?vue&type=template&id=5cef282b"
import script from "./BlacklistTable.vue?vue&type=script&lang=js"
export * from "./BlacklistTable.vue?vue&type=script&lang=js"
import style0 from "./BlacklistTable.vue?vue&type=style&index=0&id=5cef282b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports